import {ScrollTrigger} from "../LibrariesImport";

export default class Tilt {
    static init() {

        if (ScrollTrigger.isTouch === 1) {
            return;
        }

        const tiltBtns = document.querySelectorAll(".btn-fill");
        tiltBtns.forEach(element => {
            VanillaTilt.init(element, {
                reverse: false,
                max: 15 - (element.offsetWidth / 40),
                speed: 1000,
                glare: element.getAttribute("data-no-glare") !== "true",
                "max-glare": 0.4,
                perspective: 1000,
            });
        });

        const tiltHover = document.querySelectorAll(".tilt-hover");
        tiltHover.forEach(element => {
            VanillaTilt.init(element, {
                reverse: false,
                max: element.dataset.max || 15,
                speed: 1000,
                glare: element.getAttribute("data-no-glare") !== "true",
                "max-glare": 0.3
            });
        });

        const tiltFullPage = document.querySelectorAll(".tilt-full-page");
        tiltFullPage.forEach(element => {
            VanillaTilt.init(element, {
                max: element.dataset.max || 5,
                speed: 1000,
                glare: element.getAttribute("data-no-glare") !== "true",
                "max-glare": 0.3,
                "full-page-listening": true
            });
        });
    }
}